<template>
    <div class="convention-sections-lines">
        <div class="line line1"></div>
        <div class="line line2"></div>
        <div class="line line3"></div>
        <div class="line line4"></div>
        <div class="line line5"></div>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    props: ["selection"],
    components: { }
})
</script>

<style lang="sass">
=csp-position($i, $pad:0)
    left: (($i - 1) * 4px) + 1 - $pad

=line
    position: absolute
    top: 0
    bottom: 0
    width: 3px
    z-index: 5

.convention-sections-lines
    position: relative
    height: calc(100% - 65px)
    width: 30px
    left: -23px
    bottom: 50px
    top: 50px

.csp
    position: relative
    display: block

.line
    +line
    background: transparentize($color-secondary, 0.9)

.line1
    +csp-position(1)

.line2
    +csp-position(2)

.line3
    +csp-position(3)

.line4
    +csp-position(4)

.line5
    +csp-position(5)

.cc-csp-ou
    +line
    +csp-position(1)

.cc-csp-em
    +line
    +csp-position(2)

.cc-csp-am
    +line
    +csp-position(3)

.cc-csp-ca
    +line
    +csp-position(4)

.cc-csp-di
    +line
    +csp-position(5)

.cc-legend
    margin-left: $cc-legend-margin
    visibility: hidden
.csp-ou
    & > .cc-csp-ou
        visibility: visible
.csp-em
    & > .cc-csp-em
        visibility: visible
.csp-am
    & > .cc-csp-am
        visibility: visible
.csp-ca
    & > .cc-csp-ca
        visibility: visible
.csp-di
    & > .cc-csp-di
        visibility: visible

@media print
    .convention-sections-lines
        position: absolute
        left: -10mm
        top: 0
        bottom: 0
        height: auto

    .cc-legend
        margin-left: -10mm

    .convention-section-title,
    .convention-body
        .cc-legend
            margin-left: -17.5mm
</style>